//#region src/modules/Locations/constants.ts
var ALL_CHECKPOINTS_ID = "chkpt-";
var ALL_CHECKPOINT_TOURS_ID = "cktr-";
var ALL_LOCATIONS_ID = "loc-";
//#endregion
export { ALL_CHECKPOINTS_ID, ALL_CHECKPOINT_TOURS_ID, ALL_LOCATIONS_ID };

//# sourceMappingURL=constants.js.map